/* ESSIM quick-add: elk formulier met data-essim-quick voegt via Ajax toe en toont een bevestiging in de kaart. Geen automatische herhaling. */
(function(){
  if(!window.fetch) return;
  var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart";
  var D = {adding:"Toevoegen…", added:"Toegevoegd", viewCart:"Bekijk winkelwagen", or:"of", checkout:"reken af", failed:"Niet gelukt.", tryAgain:"Probeer het opnieuw.", noConn:"Geen verbinding.", checkCart:"Controleer je", beforeRetry:"voordat je opnieuw probeert.", cartWord:"winkelwagen"};
  function T(k){ var o = window.essimI18n || {}; return o[k] || D[k]; }
  function count(n){
    document.querySelectorAll(".cart-count, [data-cart-count], .cart-count-bubble span:first-child, [data-instant-dynamic-content-source=\"CART_COUNT\"]").forEach(function(el){ el.textContent = n; el.style.display = n > 0 ? "" : "none"; });
    try { document.dispatchEvent(new CustomEvent("cart:refresh", {bubbles:true})); document.dispatchEvent(new CustomEvent("cart:update", {bubbles:true, detail:{itemCount:n}})); } catch(e){}
  }
  function msgEl(form){
    var m = form.querySelector(".cartmsg");
    if(!m){ m = document.createElement("div"); m.className = "cartmsg"; m.setAttribute("role","status"); m.setAttribute("aria-live","polite"); form.appendChild(m); }
    return m;
  }
  document.addEventListener("submit", function(e){
    var form = e.target; if(!form.matches || !form.matches("form[data-essim-quick]")) return;
    e.preventDefault();
    if(form.dataset.busy === "1") return;
    var btn = form.querySelector("[type=submit]"); var old = btn ? btn.textContent : "";
    form.dataset.busy = "1"; if(btn){ btn.textContent = T("adding"); btn.setAttribute("aria-busy","true"); }
    var m = msgEl(form); m.hidden = true;
    fetch(cartUrl + "/add.js", {method:"POST", body:new FormData(form), headers:{"Accept":"application/json"}, credentials:"same-origin"})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
      .then(function(res){
        if(res.ok){
          m.className = "cartmsg ok"; m.innerHTML = "<b>" + T("added") + ".</b> <a href=\"" + cartUrl + "\">" + T("viewCart") + "</a> " + T("or") + " <a href=\"/checkout\">" + T("checkout") + "</a>."; m.hidden = false;
          if(btn) btn.textContent = T("added") + " ✓";
          fetch(cartUrl + ".js", {credentials:"same-origin"}).then(function(r){ return r.json(); }).then(function(c){ count(c.item_count); }).catch(function(){});
          setTimeout(function(){ if(btn) btn.textContent = old; }, 2500);
        } else {
          m.className = "cartmsg err"; m.innerHTML = "<b>" + T("failed") + "</b> " + ((res.d && (res.d.description || res.d.message)) || T("tryAgain")); m.hidden = false;
          if(btn) btn.textContent = old;
        }
      })
      .catch(function(){ m.className = "cartmsg err"; m.innerHTML = "<b>" + T("noConn") + "</b> " + T("checkCart") + " <a href=\"" + cartUrl + "\">" + T("cartWord") + "</a> " + T("beforeRetry"); m.hidden = false; if(btn) btn.textContent = old; })
      .then(function(){ form.dataset.busy = "0"; if(btn) btn.removeAttribute("aria-busy"); });
  });
})();
